













import { defineComponent, ref, watch } from '@vue/composition-api';
import { useFormat } from 'vivat';

const NOW_YEAR = new Date().getFullYear();

const CommonYearStartOfYearSelect = defineComponent({
  props: {
    value: {
      default: () => ({
        from: `${NOW_YEAR}-01-01`,
        to: `${NOW_YEAR}-12-31`,
      }),
    },
    label: { type: String },
    placeholder: { type: String },
  },
  setup(props, { emit }) {
    const selectedYear = ref(new Date().getFullYear() + 543);
    const backwardTenYear = Array.from({ length: 10 }, (x, i) => new Date().getFullYear() + 543 - i);

    watch(() => props.value, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        selectedYear.value = parseInt(useFormat.date(newVal.from).dayjs.format('YYYY'), 10) + 543;
      }
    });

    function emitInput(year: string) {
      const y = parseInt(year, 10);
      emit('input', {
        from: `${y - 543}-01-01`,
        to: `${y - 543}-12-31`,
      });
    }

    return {
      selectedYear,
      backwardTenYear,
      emitInput,
    };
  },
});

export default CommonYearStartOfYearSelect;
